"use strict";

var _classCallCheck = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/createClass");

var idlUtils = require("../generated/utils.js");

var _require = require("../attributes"),
    setAttributeValue = _require.setAttributeValue,
    removeAttributeByName = _require.removeAttributeByName;

var validateName = require("../helpers/validate-names").name;

var DOMException = require("domexception");

var dataAttrRe = /^data-([^A-Z]*)$/;

function attrCamelCase(name) {
  return name.replace(/-([a-z])/g, function (match, alpha) {
    return alpha.toUpperCase();
  });
}

function attrSnakeCase(name) {
  return name.replace(/[A-Z]/g, function (match) {
    return "-".concat(match.toLowerCase());
  });
}

exports.implementation =
/*#__PURE__*/
function () {
  function DOMStringMapImpl(args, privateData) {
    _classCallCheck(this, DOMStringMapImpl);

    this._element = privateData.element;
  }

  _createClass(DOMStringMapImpl, [{
    key: idlUtils.namedGet,
    value: function value(name) {
      var attributes = this._element.attributes;

      for (var i = 0; i < attributes.length; i++) {
        var attr = attributes.item(i);
        var matches = dataAttrRe.exec(attr.localName);

        if (matches && attrCamelCase(matches[1]) === name) {
          return attr.value;
        }
      }

      return undefined;
    }
  }, {
    key: idlUtils.namedSetNew,
    value: function value(name, _value) {
      if (/-[a-z]/.test(name)) {
        throw new DOMException("'".concat(name, "' is not a valid property name"), "SyntaxError");
      }

      name = "data-".concat(attrSnakeCase(name));
      validateName(name);
      setAttributeValue(this._element, name, _value);
    }
  }, {
    key: idlUtils.namedSetExisting,
    value: function value(name, _value2) {
      this[idlUtils.namedSetNew](name, _value2);
    }
  }, {
    key: idlUtils.namedDelete,
    value: function value(name) {
      name = "data-".concat(attrSnakeCase(name));
      removeAttributeByName(this._element, name);
    }
  }, {
    key: idlUtils.supportedPropertyNames,
    get: function get() {
      var result = new Set();
      var attributes = this._element.attributes;

      for (var i = 0; i < attributes.length; i++) {
        var attr = attributes.item(i);
        var matches = dataAttrRe.exec(attr.localName);

        if (matches) {
          result.add(attrCamelCase(matches[1]));
        }
      }

      return result;
    }
  }]);

  return DOMStringMapImpl;
}();